<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
import V_SHARE from "./tz";
export default {
    name: "app",
    provide() {
        return {
            reload: this.reload,
        };
    },
    data() {
        return {
            isActive: false,
            isRouterAlive: true,
        };
    },
    mounted() {
        V_SHARE(this.$t('share').title,this.$t('share').time_place);
    },
    created() {
        this.toggledev();
        window.onresize = () => {
            this.toggledev();
        };
        // window.oncontextmenu = function (event) {
        //     event.preventDefault(); // 阻止默认事件行为
        //     return false;
        // };
        // setInterval(function () {
        //     check();
        // }, 2000);
        // var check = function () {
        //     function doCheck(a) {
        //         if (("" + a / a)["length"] !== 1 || a % 20 === 0) {
        //             (function () {}["constructor"]("debugger")());
        //         } else {
        //             (function () {}["constructor"]("debugger")());
        //         }
        //         doCheck(++a);
        //     }
        //     try {
        //         doCheck(0);
        //     } catch (err) {}
        // };
    },
    methods: {
        changeLang(e) {
            let lang = e.target.dataset.lang;
            this.$i18n.locale = lang;
            this.isActive = lang == "zh" ? true : false;
        },
        isMobile() {
            let flag = navigator.userAgent.match(
                // match方法可在字符串内检索指定的值，
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            return flag;
        },
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function () {
                this.isRouterAlive = true;
            });
        },
        toggledev() {
            let str = window.location.href.substring(
                window.location.href.lastIndexOf("/") + 1,
                window.location.href.length
            );
            let lang = localStorage.getItem("lang");

            if (this.isMobile()) {
                if (str == "") {
                    this.$router.replace("/index").catch(() => {});
                } else {
                    this.$router.replace("/" + str).catch(() => {});
                }
            } else {
                if (lang == "" || lang == null) {
                    localStorage.setItem("lang", "zh");
                }
                if (str == "") {
                    this.$router.replace("/pc/index").catch(() => {});
                } else {
                    this.$router.replace("/pc/" + str).catch(() => {});
                }
            }
        },
    },
};
</script>

<style>
@import "assets/css/index.css";
.psap {
    width: 40px;
    height: 40px;
    background: url(assets/a1.png) no-repeat;
    background-size: 161px auto;
    position: absolute;
    top: 100%;
    left: 50%;
    z-index: 1000;
    transform-origin: center bottom;
}
.psap1 {
    width: 60px;
    height: 60px;
    background: url(assets/a1.png) no-repeat;
    background-size: 240px auto;
    position: absolute;
    top: 100%;
    left: 50%;
    z-index: 1000;
    transform-origin: center bottom;
}
</style>


// WEBPACK FOOTER //
// src/App.vue